import { isBoundedValueSetField, MetadataEntityFieldData } from '@jms/model';

/**
 * Kanban Column pool: groupable fields whose value set is bounded.
 *
 * Columns are the field's FULL value set, rendered whether or not the current page has items for each
 * one, so a field with unbounded values (a job number, a customer, a date) would produce a column per
 * record — a board nobody can read. `isBoundedValueSetField` keeps the pool to settings-style
 * reference lists and enums. Rows are unconstrained by this: an open field groups fine as a row,
 * because rows stay data-driven from the loaded page.
 *
 * Scope is already applied upstream by `resolveUiFields`, so an embedded field arrives with its
 * absolute path (`workOrders.status`) — the same id a saved view stores, which is why the dropdown
 * echoes the saved selection instead of falling back to None.
 */
export function resolveKanbanColumnFields(uiFields: MetadataEntityFieldData[]): MetadataEntityFieldData[] {

  return uiFields.filter(field => !!field.groupable && isBoundedValueSetField(field));
}
